var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.menuItems.length)?_c('Menu'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }